import React, { ReactElement } from 'react'

import { useTranslation } from 'react-i18next'

import { EventStatus as EventStatusType, getColorForEventStatus, getLabelForEventStatus } from '../events.helper'

import styles from './EventStatus.module.less'

type EventStatusProps = {
  status: EventStatusType
}

export default function EventStatus({ status }: EventStatusProps): ReactElement {
  const { t } = useTranslation()

  return (
    <div className={styles.EventStatus_Container}>
      <div
        className={`${styles.EventStatus_Status}`}
        data-testid="event-status"
        style={{ backgroundColor: `${getColorForEventStatus(status)}` }}
      >
        {t(getLabelForEventStatus(status))}
      </div>
    </div>
  )
}
